import React from 'react'
import Breadcrumb from '../Cart/Breadcrumb'
import Contact from './Contact'

const ContactUs = () => {
  return (
    <>
        <Breadcrumb title={"Contact Us"} />

        <Contact />
    </>
  )
}

export default ContactUs